import cAppeared from '../components/c-appeared';
import cOutline from '../components/c-outline';
import preloader from '../components/c-preloader';

cAppeared();
cOutline();
preloader();
